import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  Button,
  Chip,
} from '@mui/material';
import { StatusChip, formatCurrency, formatDateTime } from 'components/shared';

const OrderSummary = ({ order }) => {
  if (!order) return null;

  const shipping = order.shippingAddress || {};
  const mapQuery = [
    shipping.street,
    shipping.city,
    shipping.state,
    shipping.pincode,
    shipping.country,
  ]
    .filter(Boolean)
    .join(', ');

  const handleShowMap = () => {
    if (!mapQuery) return;
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQuery)}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const handlePrintInvoice = () => window.print();

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">
            Order: {order.orderNumber || `#${order._id?.slice(-6)}`}
          </Typography>
          <Box padding={1}>
            <Button
              variant="contained"
              sx={{ mr: 2 }}
              size="small"
              onClick={handleShowMap}
              disabled={!mapQuery}
            >
              Show Locations on Map
            </Button>
            <Button variant="contained" size="small" onClick={handlePrintInvoice}>
              Print Invoice
            </Button>
          </Box>
        </Box>

        <Grid sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Grid>
            <Typography variant="body2">
              {formatDateTime(order.invoiceDate || order.createdAt)}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Typography variant="body2">Invoice: </Typography>
              <Chip label={order.invoiceNumber || '—'} sx={{ ml: 1 }} />
            </Box>
          </Grid>

          <Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 1 }}>
              <Typography variant="body2">Status:</Typography>
              <Box sx={{ ml: 1 }}>
                <StatusChip status={order.status} />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
              <Typography variant="body2">Payment Method:</Typography>
              <Typography variant="body2" sx={{ ml: 1, textTransform: 'capitalize' }}>
                {order.paymentMethod || '—'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 1 }}>
              <Typography variant="body2">Payment Status:</Typography>
              <Box sx={{ ml: 1 }}>
                <StatusChip status={order.paymentStatus} />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
              <Typography variant="body2">Total:</Typography>
              <Typography variant="body2" sx={{ ml: 1 }}>
                {formatCurrency(order.total)}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default OrderSummary;
